import React, { lazy, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from "app/hooks";
import indexRoutes from 'routes';
import { Route, Router, Switch } from 'react-router-dom';
import { appHistory } from 'routes/appHistory';
import { PrivateRoute } from 'routes/PrivateRoutes';
import BlankLayout from 'components/layouts/BlankLayout';
import { useFirebaseMessaging } from 'hooks';
import { initializeFirebasePerformance } from 'services/firebase';
import Thinfinity from '../components/Thinfinity';
import { getLocalStorage, setLocalStorage } from "../utils";
import { startPolling, stopPolling } from "../features/alarmQueue/alarmQueueSlice";
import { selectHasSac, selectSacInfo } from "../features/common/commonSelectors";
import ErrorBoundary from 'components/common/ErrorBoundary';

// Página pública de revisión de liquidaciones: se abre desde el correo, sin sesión.
const BillingReview = lazy(() => import('containers/BillingReview'));

const existsUserLogged = getLocalStorage('userLogged');
!existsUserLogged && setLocalStorage('userLogged', null);
!existsUserLogged && setLocalStorage('locale', 'en');
!existsUserLogged && setLocalStorage('systemOfMeasurement', null);
!existsUserLogged && setLocalStorage('dateFormat', null);

const App = () => {

  const dispatch = useAppDispatch();

  const sacInfo = useAppSelector(selectSacInfo);
  const hasSac = useAppSelector(selectHasSac);

  useFirebaseMessaging();

  useEffect(() => {
    initializeFirebasePerformance();
  }, []);

  useEffect(() => {

    if (sacInfo !== null && hasSac) {
      console.log("[App] Session success → startPolling()");
      dispatch(startPolling());
    }

    return () => {
      dispatch(stopPolling());
    };
  }, [sacInfo, hasSac, dispatch]);

  return (
    <>
      <Router history={appHistory}>
        <ErrorBoundary>
          <Switch>
            <Route exact path="/authentication/Login" component={BlankLayout} />
            <Route exact path="/billing-review/:token" component={BillingReview} />
            {indexRoutes.map((prop, key) => {
              return <PrivateRoute key={key} path={prop.path} component={prop.component} />;
            })}
          </Switch>
        </ErrorBoundary>
        <Thinfinity />
      </Router>
    </>
  );
};

export default App;
